import makeLookupModal from "../../UI/LookupModal/LookupModal";
import StudentLoadIntentStatusLookup from "./StudentLoadIntentStatusLookup";
const StudentLoadIntentStatusLookupModal = makeLookupModal(StudentLoadIntentStatusLookup, {
    pluralEntityName: "Student Load Intents",
});
export default StudentLoadIntentStatusLookupModal;
